import React from 'react';
import AuthPageTemplate from './template/auth-page';
import ProfilePwdPanel from './../ui/panel/profile-pwd';
import ProfileMenu from './../ui/menu/profile';

const ProfilePwdPage = () => {
    return (
        <AuthPageTemplate childMenu={
            <div>
                <ProfileMenu />
            </div>
        }>
            <ProfilePwdPanel />
        </AuthPageTemplate>
    );
};

export default ProfilePwdPage;
